import { apiClient } from "@/lib/api-client";

export type LogItem = {
  id?: string | number;
  message?: string;
  level?: string;
  timestamp?: string;
  meta?: any;
  [key: string]: any;
};

export type GetLogsResponse = {
  datas?: LogItem[];
  data?: LogItem[];
  message?: string;
  total?: number;
};

export const getLogs = async ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<GetLogsResponse> => {
  const sysName = import.meta.env.VITE_API_LOOGER_SYSNAME || "remun_service";
  const apiKey = import.meta.env.VITE_API_LOGGER_API_KEY || "";

  // Set cookies as requested
  document.cookie = `X-System-Name=${sysName}; path=/`;
  document.cookie = `X-API-Key=${apiKey}; path=/`;

  const params = new URLSearchParams({
    startDate,
    endDate,
  });

  const resData = await apiClient<any>(
    `/api-logger/logs/${sysName}?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
        "X-System-Name": sysName,
        "X-API-Key": apiKey,
      },
    },
  );

  return resData;
};
